import React, { Component } from "react";
import { Props, State } from "./ErrorBoundary.props";

class ErrorBoundary extends Component<Props, State> {
    public state: State = { hasError: false };

    public static getDerivedStateFromError(_: Error): State {
        return {
            hasError: true,
        };
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                    <h4 className="text-danger bold">خطایی رخ داده است :(</h4>
                </div>
            );
        }

        return <>{this.props.children}</>;
    }
}

export default ErrorBoundary;
